// Task definitions with names and max points
export const taskDefinitions = {
  AIDO1: { name: "Fetch raw order book", maxPoints: 3 },
  AIDO2: { name: "Display normalized book", maxPoints: 1 },
  AIDO3: { name: "Order placement", maxPoints: 2 },
  AIDO4: { name: "Authentication", maxPoints: 2 },
  AIDO5: { name: "Augmented book view", maxPoints: 1 },
  AIDO6: { name: "Highlight local vs external orders", maxPoints: 1 },
  AIDO7: { name: "Live updates via polling/ws", maxPoints: 3 },
  AIDO8: { name: "Limit-order matching", maxPoints: 4 },
  AIDO9: { name: "Market-order matching", maxPoints: 3 },
  AIDO10: { name: "Show local fills list", maxPoints: 3 },
  AIDO11: { name: "Order cancellation", maxPoints: 2 },
  AIDO12: { name: "Order modification", maxPoints: 2 },
  AIDO13: { name: "Multi-symbol selector", maxPoints: 3 },
  AIDO14: { name: "Depth-chart visualization", maxPoints: 5 },
  AIDOFR: { name: "Persistence in DB", maxPoints: 4 } // counts twice
};

// NOFR categories and point distribution
export const nofrCategories = {
  gitPush: { name: "Git push", distribution: [4, 3, 2, 1] },
  tests: { name: "Tests", distribution: [4, 3, 2, 1] },
  beauty: { name: "Beauty/style", distribution: [8, 6, 4, 2] }
};

// Calculate total score for a team
export const calculateTotalScore = (team) => {
  // Calculate AIDO task scores
  const aidoScore = Object.values(team.aidoScores).reduce(
    (total, score) => total + score.earned, 
    0
  );
  
  // AIDOFR counts twice
  const aidofrBonus = team.aidoScores.AIDOFR ? team.aidoScores.AIDOFR.earned : 0;
  
  // Calculate NOFR scores
  const nofrScore = Object.values(team.nofrScores).reduce(
    (total, score) => total + score, 
    0
  );
  
  return aidoScore + aidofrBonus + nofrScore;
};

// Team data with scores
export const teamsData = [
  {
    id: 1,
    name: "BaxterWarriors",
    rank: 1, // Will be calculated and updated
    aidoScores: {
      AIDO1: { earned: 3, max: 3 },
      AIDO2: { earned: 0, max: 1 },
      AIDO3: { earned: 2, max: 2 },
      AIDO4: { earned: 2, max: 2 },
      AIDO5: { earned: 1, max: 1 },
      AIDO6: { earned: 1, max: 1 },
      AIDO7: { earned: 3, max: 3 },
      AIDO8: { earned: 2, max: 4 },
      AIDO9: { earned: 0, max: 3 },
      AIDO10: { earned: 3, max: 3 },
      AIDO11: { earned: 2, max: 2 },
      AIDO12: { earned: 0, max: 2 },
      AIDO13: { earned: 0, max: 3 },
      AIDO14: { earned: 0, max: 5 },
      AIDOFR: { earned: 8, max: 4 }
    },
    nofrScores: {
      gitPush: 4,
      tests: 0,
      beauty: 8
    }
  },
  {
    id: 2,
    name: "FIAt-5.0.0",
    rank: 2,
    aidoScores: {
      AIDO1: { earned: 3, max: 3 },
      AIDO2: { earned: 1, max: 1 },
      AIDO3: { earned: 2, max: 2 },
      AIDO4: { earned: 0, max: 2 },
      AIDO5: { earned: 1, max: 1 },
      AIDO6: { earned: 1, max: 1 },
      AIDO7: { earned: 3, max: 3 },
      AIDO8: { earned: 0, max: 4 },
      AIDO9: { earned: 0, max: 3 },
      AIDO10: { earned: 0, max: 3 },
      AIDO11: { earned: 0, max: 2 },
      AIDO12: { earned: 0, max: 2 },
      AIDO13: { earned: 0, max: 3 },
      AIDO14: { earned: 0, max: 5 },
      AIDOFR: { earned: 0, max: 4 }
    },
    nofrScores: {
      gitPush: 3,
      tests: 0,
      beauty: 2
    }
  },
  {
    id: 3,
    name: "Glourious-Basterds",
    rank: 3,
    aidoScores: {
      AIDO1: { earned: 3, max: 3 },
      AIDO2: { earned: 0, max: 1 },
      AIDO3: { earned: 2, max: 2 },
      AIDO4: { earned: 2, max: 2 },
      AIDO5: { earned: 0, max: 1 },
      AIDO6: { earned: 0, max: 1 },
      AIDO7: { earned: 3, max: 3 },
      AIDO8: { earned: 0, max: 4 },
      AIDO9: { earned: 0, max: 3 },
      AIDO10: { earned: 0, max: 3 },
      AIDO11: { earned: 0, max: 2 },
      AIDO12: { earned: 0, max: 2 },
      AIDO13: { earned: 0, max: 3 },
      AIDO14: { earned: 0, max: 5 },
      AIDOFR: { earned: 0, max: 4 }
    },
    nofrScores: {
      gitPush: 1,
      tests: 0,
      beauty: 6
    }
  },
  {
    id: 4,
    name: "LelkesneTomannRozaliaHevizVarosSportcsarnok",
    rank: 4,
    aidoScores: {
      AIDO1: { earned: 3, max: 3 },
      AIDO2: { earned: 1, max: 1 },
      AIDO3: { earned: 2, max: 2 },
      AIDO4: { earned: 2, max: 2 },
      AIDO5: { earned: 1, max: 1 },
      AIDO6: { earned: 1, max: 1 },
      AIDO7: { earned: 3, max: 3 },
      AIDO8: { earned: 0, max: 4 },
      AIDO9: { earned: 0, max: 3 },
      AIDO10: { earned: 0, max: 3 },
      AIDO11: { earned: 2, max: 2 },
      AIDO12: { earned: 0, max: 2 },
      AIDO13: { earned: 0, max: 3 },
      AIDO14: { earned: 0, max: 5 },
      AIDOFR: { earned: 8, max: 4 }
    },
    nofrScores: {
      gitPush: 2,
      tests: 0,
      beauty: 4
    }
  }
];

// Process teams data to calculate total scores and ensure correct ranking
export const processTeamsData = () => {
  // Calculate total scores for each team
  const teamsWithScores = teamsData.map(team => ({
    ...team,
    totalScore: calculateTotalScore(team)
  }));
  
  // Sort teams by total score (descending)
  const sortedTeams = [...teamsWithScores].sort((a, b) => b.totalScore - a.totalScore);
  
  // Assign ranks based on sorted order
  return sortedTeams.map((team, index) => ({
    ...team,
    rank: index + 1
  }));
};

// Export the processed teams data
export const teams = processTeamsData();

// Export the complete competition data
export const competitionData = {
  teams,
  taskDefinitions
};

export default competitionData;